<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('notification.page_header') }}</slot>
            <slot slot="description">
                <p>Intro notification - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo.</p>
            </slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-700 c-form-row">

                    <v-form-row>
                        <v-input v-model="Notification.Title" name="notification_title" :fluid="true" :error="Validate.Title">
                            <slot slot="label">{{ $t('notification.label.title') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-rich-text-editor :value="Notification.ContentNL" name="notification_content_nl" :fluid="true" :toolbar="simpleRTEToolbar" @input="updateNL">
                            <slot slot="label">{{ $t('notification.label.content_nl') }}</slot>
                        </v-rich-text-editor>
                    </v-form-row>

                    <v-form-row>
                        <v-rich-text-editor :value="Notification.ContentFR" name="notification_content_fr" :fluid="true" :toolbar="simpleRTEToolbar" @input="updateFR">
                            <slot slot="label">{{ $t('notification.label.content_fr') }}</slot>
                        </v-rich-text-editor>
                    </v-form-row>

                    <v-form-row>
                        <v-rich-text-editor :value="Notification.ContentEN" name="notification_content_en" :fluid="true" :toolbar="simpleRTEToolbar" @input="updateEN">
                            <slot slot="label">{{ $t('notification.label.content_en') }}</slot>
                        </v-rich-text-editor>
                    </v-form-row>

                    <v-form-row>
                        <v-datepicker v-model="Notification.StartDate" :label="$t('notification.label.start_date')" :error="Validate.StartDate" :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-datepicker v-model="Notification.EndDate" :label="$t('notification.label.end_date')" :error="Validate.EndDate" :fluid="true"></v-datepicker>
                    </v-form-row>

                    <v-form-row>
                        <v-custom-select v-model="Notification.Branches" 
                                        :options="BranchOptions"
                                         option-name="FullName"
                                         option-value="Id"
                                         :error="Validate.Branches"
                                         name="branch"
                                         search-label="FullName"
                                         track-by="Id"
                                         :fluid="true" 
                                         :multiple="true">
                            <slot slot="label">{{ $t('notification.label.branches') }}</slot>
                        </v-custom-select>
                    </v-form-row>

                    <v-form-row>
                        <v-switch v-model="Notification.ShowToMainUserOnly" name="notification_show_main_user_only">
                            <slot slot="label">{{ $t('notification.label.show_main_user_only') }}</slot>
                        </v-switch>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('notification.button.create') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFilters from '@/components/form/filters/Filters'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'
    import VRichTextEditor from '@/components/form/RichTextEditor'
    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VDatepicker,
            VTargetListSelect,
            VSwitch,
            VRichTextEditor
        },
        data() {
            return {
                Validate: {},
                loaded: {},
                simpleRTEToolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ 'script': 'sub'}, { 'script': 'super' }],
                    ['color', 'background'],
                    ['link']
                ]
            }
        },
        computed: {
            ...mapGetters({
                BranchOptions: 'BranchOptions',
                Notification: 'Notification'
            }),
        },
        created: function () {
            this.$store.dispatch('getBranchOptions');
            this.$store.dispatch('getNotification', this.$attrs.id).then(() => {
                this.loaded = { isLoaded: true }
            });
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}
                this.$store.dispatch('updateNotification', this.Notification).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'NotificationOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            }, 
            updateNL(newValue) {
                this.Notification.ContentNL = newValue;
            }, 
            updateFR(newValue) {
                this.Notification.ContentFR = newValue;
            }, 
            updateEN(newValue) {
                this.Notification.ContentEN = newValue;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/admin/notification/Edit.vue